<!--
 * @Author: HuaShengJin
 * @Date: 2026-04-01
 * @Description: 空数据占位组件
-->
<template>
  <div
    class="empty-placeholder"
    :class="{ 'empty-placeholder--fill': fill }"
  >
    <el-empty
      :image-size="imageSize"
      :description="emptyDescriptionProp"
    >
      <template
        v-if="$slots.image"
        #image
      >
        <slot name="image" />
      </template>
      <template
        v-if="$slots.description"
        #description
      >
        <slot name="description" />
      </template>
      <slot />
    </el-empty>
  </div>
</template>

<script>
export default {
  name: 'EmptyPlaceholder',
  props: {
    /** 不传或空字符串时使用 i18n `common.noData` */
    description: {
      type: String,
      default: ''
    },
    imageSize: {
      type: Number,
      default: 96
    },
    /**
     * 在剩余区域内水平垂直居中展示。
     * 典型用法：父级为列方向 flex，且中间区域 `flex:1; min-height:0`，本组件设 `fill` 即可撑满该区域。
     * 父级若已是 flex + align-items/justify-content 居中，亦可配合使用。
     */
    fill: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    displayDescription() {
      const t = (this.description || '').trim()
      return t || this.$t('common.noData')
    },
    /** 使用 #description 插槽时不传 prop，避免与 Element Plus 重复展示 */
    emptyDescriptionProp() {
      return this.$slots.description ? undefined : this.displayDescription
    }
  }
}
</script>

<style lang="scss" scoped>
.empty-placeholder {
  :deep(.el-empty__description) {
    margin-top: 12px;
    padding: 0 16px;
    font-size: 14px;
    color: #8c8c8c;
    line-height: 1.5;
  }

  &--fill {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    box-sizing: border-box;
    flex: 1 1 auto;
    min-height: 0;
  }
}
</style>
